/**
 * @readonly
 * @enum { string }
 */
export const ExerciseStatus = {
    CREATED: 'CREATED',
    COMPLETED: 'COMPLETED',
    CURRENT: 'CURRENT',
}